import { Mail } from '@mui/icons-material';
import { Button, Card, CardActions, CardContent, CardMedia, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ICompanyClientViewModel } from 'viewModels';
import { Download } from '../../../controller/FileController';

interface CardClientProps {
  c: ICompanyClientViewModel;
  disabled: (id: string) => void;
}

export const CardClient = ({ disabled, c }: CardClientProps) => {
  const navigate = useNavigate();

  const [pictureProfile, setPictureProfile] = useState<null | string>(null);

  useEffect(() => {
    if (c.pictureProfileId) {
      Download(c.pictureProfileId).then((response) =>
        setPictureProfile(URL.createObjectURL(response)),
      );
    }
  }, [c]);

  return (
    <Grid item xs={12} md={6} lg={4} xl={3}>
      <Card>
        <CardMedia
          sx={{ height: 260, width: '100%' }}
          image={pictureProfile ?? '/static/media/userIcon.0b9b6b6ac151caf60a2fd3302b477ce4.svg'}
          title={c.name}
        />
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {c.name}
          </Typography>
          <p style={{ display: 'flex', alignItems: 'center' }}>
            <Mail style={{ width: '1.3rem' }} /> {c.email}
          </p>
          <p>{c.document}</p>
        </CardContent>
        <CardActions>
          <Button size="small" onClick={() => navigate(`/user/${c.url}`)}>
            Ver Perfil
          </Button>
          <Button
            size="small"
            color={c.disabled ? 'success' : 'error'}
            onClick={() => disabled(c.id)}>
            {c.disabled ? 'Habilitar' : 'Desabilitar'}
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};
